import {
  ReportContainer,
  SectionLight,
  SectionDark,
  PageHeader,
  HeaderText,
  LineText,
  LineTextBoxed,
  LineKey,
  LineVal,
  ReportDetail,
} from "./qapi_template.styles";
import moment from "moment";
import { ESTIMATED_DATE_TIME_LABEL } from "../../components/EstimatedDateTime";

const QapiHeader = ({ reportHeading, isNonQapi }: any) => {
  return (
    <ReportContainer>
      <SectionLight>
        <PageHeader>
          {isNonQapi ? (
            <span>Incident Report</span>
          ) : (
            <span>Full QA<br />Incident Report</span>
          )}
        </PageHeader>
      </SectionLight>
      <SectionDark>
        <ReportDetail>
          <HeaderText>{reportHeading.facilityName}</HeaderText>
          <LineText><LineKey>Incident type: </LineKey><LineVal>{reportHeading.incidentType}</LineVal></LineText>
          <LineText><LineKey>Incident number: </LineKey><LineVal>{reportHeading.incidentNumber}</LineVal></LineText>
          <LineText>
            <LineKey>
              {reportHeading?.isEstimatedDateTime
                ? `${ESTIMATED_DATE_TIME_LABEL}: `
                : "Incident date/time: "}
            </LineKey>
            <LineVal>
              {reportHeading?.facilityDateTime
                ? moment(reportHeading?.facilityDateTime).format("dddd, MMMM DD YYYY, h:mm a")
                : "-"}
            </LineVal>
          </LineText>
        </ReportDetail>
      </SectionDark>
      <SectionLight>
        <ReportDetail>
          <HeaderText>Resident Details</HeaderText>
          <LineTextBoxed><LineKey>Resident: </LineKey><LineVal>{reportHeading?.residentName || "-"}</LineVal></LineTextBoxed>
          <LineTextBoxed><LineKey>Date of Birth: </LineKey><LineVal>
            {reportHeading?.dob
              ? moment(reportHeading?.dob).format("MM/DD/YYYY")
              : "-"}</LineVal></LineTextBoxed>
          <LineTextBoxed><LineKey>Medical Record Number: </LineKey><LineVal>{reportHeading.mrn || "-"}</LineVal></LineTextBoxed>
          <LineTextBoxed><LineKey>Location: </LineKey><LineVal>{reportHeading?.location || "-"}</LineVal></LineTextBoxed>
        </ReportDetail>
      </SectionLight>
    </ReportContainer>
  );
};
export default QapiHeader;

